module.exports = __webpack_public_path__ + "media/images/flags/gh-d060e231aa94a98e78d96e709c1f9914.svg";